import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { Moment } from 'moment'

import { TripKeys } from '../reactQueryKeys'

import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { getFlightSchedule } from 'tripPlanner/api/misc/flightStatus'
import { GetFlightScheduleError } from 'tripPlanner/api/types'
import * as Mappers from 'tripPlanner/mappers'
import { FlightSchedule } from 'tripPlanner/types/common'
import { sortFlightSchedules } from 'tripPlanner/utils/flights'

interface Args {
  flightCode: string
  departureDate: Moment
}

export const useGetFlightSchedules = (
  { departureDate, flightCode }: Args,
  options?: UseQueryOptions<
    Awaited<ReturnType<typeof getFlightSchedule>>,
    GetFlightScheduleError,
    FlightSchedule[]
  >,
): UseQueryResult<FlightSchedule[], GetFlightScheduleError> => {
  return useQuery({
    queryKey: TripKeys.flightSchedule(
      flightCode,
      departureDate.format(ISO_DATE_FORMAT),
    ),
    queryFn: () => getFlightSchedule({ flightCode, departureDate }),
    select: (flights) => {
      const mappedFlights = flights.map(Mappers.flightSchedule)
      return sortFlightSchedules(mappedFlights)
    },
    ...options,
  })
}
